import { ProblemDefinitionView } from '@/features/enhance-common/components/problem-definition-view';
import { useLocationOptions } from '@/features/enhance-common/hooks/use-location-options';

import { useProjectListingSuggestionState } from '../use-project-listing-suggestion.state';

export const ProblemDefinitionViewWrapper = () => {
  const state = useProjectListingSuggestionState();
  const { setOptions: setLocationOptions } = useLocationOptions();

  return (
    <ProblemDefinitionView
      problemDescription={state.problemStatement}
      desiredSolution={state.desiredSolution}
      locations={state.locations}
      onProblemDescriptionChange={state.setProblemStatement}
      onDesiredSolutionChange={state.setDesiredSolution}
      onLocationsChange={state.setLocations}
      setLocationOptions={setLocationOptions}
      showTooltips
      dataTestId="problem-definition-view"
    />
  );
};
